<div
  #canvas
  class="canvas-renderer"
  style="position: relative; display: block; height: 100%; width: 100%; overflow: hidden; user-select: none"
  (wheel)="$event.preventDefault()"
>
  <app-canvas-scroller
    [size]="size()"
    style="position: absolute; width: 100%; height: 100%"
    (panned)="handlePanned($event)"
    (dragStateChanged)="handleDragStateChanged($event)"
  />

  <div class="elements" style="position: absolute; inset: 0; isolation: isolate; pointer-events: none">
    @for (el of elements(); track el.uid) {
      @let pos = calculateElementPosition(el);
      @let _overrides = overrides()?.[el.uid] ?? {};
      <app-canvas-element
        [el]="el"
        (clicked)="el.isClickable ? clicked.emit(el.uid) : undefined"
        (grabbed)="handleGrab($event, el.uid)"
        (dragged)="handleDrag($event, el.uid)"
        (dropped)="handleDrop($event, el.uid)"
        [style]="{
          display: 'block',
          position: 'absolute',
          left: 100 * pos[0] + '%',
          top: 100 * pos[1] + '%',
          width: 100 * el.size[0] + '%',
          height: 100 * el.size[1] + '%',
          pointerEvents: disablePointerEvents() ? 'none' : el.isClickable || el.draggable ? 'initial' : 'none',
          translate: _overrides.position
            ? screenSize()[0] * _overrides.position[0] + 'px ' + screenSize()[1] * _overrides.position[1] + 'px'
            : undefined,
          transition: 'translate 0.1s ease-out',
          zIndex: _overrides.zIndex,
        }"
      />
    }
  </div>

  <lp-canvas-renderer-arrows [origin]="origin()" [size]="size()" (screenSizeUpdated)="screenSize.set($event)" />
</div>
